import { PaginatedRepackSamples } from './repack.gql';

const repackQueries = (guid?: string) => ({
    samples: {
        query: PaginatedRepackSamples,
        pathToItems: 'paginatedRepackSamples',
        pathToTotalItems: 'totalSampleRecords',
        variables: {
            repackGuid: guid,
        },
        skip: !guid,
    },
    packs: undefined,
});

export default repackQueries;
